import React from 'react';
import { useRouter } from 'next/router';
import { useTranslation } from 'next-i18next';
import styles from "./style.module.scss";

const Hero = () => {
    const { push } = useRouter();
    const { t } = useTranslation('common');

    const cards = [
        { title: t('hero.categories.design'), img: "/static/img/HomePage/design.webp" },
        { title: t('hero.categories.scientific_works'), img: "/static/img/HomePage/file.webp" },
        { title: t('hero.categories.programming'), img: "/static/img/HomePage/web.webp" },
        { title: t('hero.categories.3d_models'), img: "/static/img/HomePage/3d.webp" },
    ];

    return (
        <section className={styles.heroSection}>
            <div className={styles.heroContent}>
                <h1 className={styles.heroTitle}>
                    {t('hero.title')}
                </h1>
                <p className={styles.heroParagraph}>
                    {t('hero.description')}
                </p>
                <div className={styles.heroButtons}>
                    <button className={styles.primaryButton} onClick={() => push("/auth/register")}>
                        {t('hero.post_services')}
                        <img src="/static/img/HomePage/whitearrow.svg" alt="Arrow" />
                    </button>
                    <button className={styles.dashedButton} onClick={() => push("/auth/register")}>
                        {t('hero.upload_products')}
                    </button>
                </div>
            </div>

            <div className={styles.cardsGrid}>
                {cards.map((card, index) => (
                    <div
                        key={card.title}
                        className={`${styles.cardWrapper} ${index % 2 !== 0 ? styles.staggered : ''}`}
                    >
                        <HeroCard title={card.title} img={card.img} />
                    </div>
                ))}
            </div>
        </section>
    );
};

export default Hero;


const HeroCard = ({ title, img }: { title: string, img: string }) => {
    return (
        <div className={styles.hero_card}>
            <div className={styles.card_img_wrapper}>
                <img className={styles.card_img} src={img} alt="card_image" />
            </div>
            <div className={styles.card_title_wrapper}>
                <p className={styles.card_title}>{title}</p>
            </div>
        </div>
    )
}